//停车管理
export default [
  {
    path: '/vipCar',
    component: () => import('../pages/plateManage/vipCar.vue'),
    name: 'vipCar',
    title: '内部车管理',
    meta: {
      title: '内部车管理',
    },
  },
  {
    path: '/bookingCar',
    component: () => import('../pages/plateManage/bookingCar.vue'),
    name: 'bookingCar',
    title: '预约车管理',
    meta: {
      title: '预约车管理',
    },
  },
  {
    path: '/plateOrder',
    component: () => import('../pages/plateManage/plateOrder.vue'),
    name: 'plateOrder',
    title: '停车缴费订单',
    meta: {
      title: '停车缴费订单',
    },
  },
]
